module.exports = "<p>view-employee-details works!</p>\n"